export const SET_SORT = 'SET_SORT'

export const setSort = (payload: any) => (dispatch: any) =>
  dispatch({
    type: SET_SORT,
    payload,
  })
